<template>
  <PlanSummaryCardText :title="planSummaryTitle" :pricing="planPricing" :subheading="subheading" :trialInfo="trialDisplay" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import PlanSummaryCardText from './PlanSummaryCardText.vue'
import { useCheckoutStore } from '@/store/CheckoutStore'
import { usePlanStore } from '@/store/PlanStore'
import { usePriceStore } from '@/store/PriceStore'
import { useProductStore } from '@/store/ProductStore'
import { useSubscriptionStore } from '@/store/SubscriptionStore'
const checkoutStore = useCheckoutStore()
const planStore = usePlanStore()
const priceStore = usePriceStore()
const productStore = useProductStore()
const subscriptionStore = useSubscriptionStore()

const { isInTrial } = storeToRefs(subscriptionStore)
const { country } = storeToRefs(checkoutStore)
const { name: productName } = storeToRefs(productStore)
const { selectedPlanDisplayPrice } = storeToRefs(priceStore)

const { selectedPlanIntervalAsNoun } = storeToRefs(planStore)

const preTaxDetails = computed(() => (country.value === 'US' ? '(pre-tax)' : ''))

const planSummaryTitle = computed(() => productName.value)
const subheading = computed(() => `${trialEmailDisplay.value} Cancel anytime.`)

const planPricing = computed(() => `${selectedPlanDisplayPrice.value}/${selectedPlanIntervalAsNoun.value} ${preTaxDetails.value}`)

const trialDisplay = computed(() => (isInTrial.value ? 'once your trial ends.' : 'starting today.'))
const trialEmailDisplay = computed(() => (isInTrial.value ? "We'll remind you three days before your trial ends." : ''))
</script>
